import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type StatusFragment = { id: string, name: string, progress?: number | null, category: Types.StatusCategoryEnum, order?: number | null, icon?: { type: Types.IconTypeEnum, value: string } | null };


export type StatusFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const StatusFragmentDoc = /*#__PURE__*/ gql`
    fragment Status on StatusType {
  id
  name
  progress
  category
  order
  icon {
    type
    value
  }
}
    `;